import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { PREFIX_PATTERN } from "@/core/locale";

Vue.use(VueRouter);

const routes = [
    {
        // Hungarian at the root, other languages under /en/..., /da/...
        path: `/:lang(${PREFIX_PATTERN})?`,
        component: { render: h => h("router-view") },
        children: [
            {
                path: "",
                name: "Home",
                component: Home,
                meta: { title: "Címkézz magadnak, légy egyedi!" }
            },
            {
                path: "contact",
                name: "Contact",
                meta: { title: "Kapcsolat" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "contact" */ "../views/Contact.vue"
                    )
            },
            {
                path: "blog",
                name: "Blog",
                meta: { title: "Blog" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(/* webpackChunkName: "blog" */ "../views/Blog.vue")
            },
            {
                path: "blog/:slug",
                name: "Article",
                meta: { title: "Cikkek" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "blog" */ "../views/Article.vue"
                    )
            },
            {
                path: "profile/:tab?",
                name: "Profile",
                meta: {
                    requiresAuth: true,
                    title: "Profilom"
                },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "profile" */ "../views/Profile.vue"
                    )
            },
            {
                path: "cart",
                name: "Cart",
                meta: { title: "Kosár" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(/* webpackChunkName: "cart" */ "../views/Cart.vue")
            },
            {
                path: "creator",
                name: "Creator",
                meta: { title: "Matricatervező" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "creator" */ "../views/Creator.vue"
                    )
            },
            {
                path: "registration",
                name: "Registration",
                meta: { title: "Regisztráció" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "registration" */ "../views/Registration.vue"
                    )
            },
            {
                path: "about",
                name: "About",
                meta: { title: "Rólunk" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(/* webpackChunkName: "about" */ "../views/About.vue")
            },
            {
                path: "payment-finish",
                name: "PaymentFinish",
                meta: { title: "Sikeres fizetés" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "payment-finish" */ "../views/PaymentFinish.vue"
                    )
            },
            {
                path: "404",
                name: "404",
                meta: { title: "404" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(/* webpackChunkName: "404" */ "../views/404.vue")
            },
            {
                path: "*",
                name: "Static",
                meta: { title: "" },
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () =>
                    import(
                        /* webpackChunkName: "Static" */ "../views/Static.vue"
                    )
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
});

export default router;
